<template>
  <div>
    <div
      class="medical-entity"
      v-for="(item, index) in biosHeadCommentBoList"
      :key="index"
    >
      <div class="column">
        <div class="column-time">
          {{ $t('profile.submittedOn') }}{{ item.timesDate }}
        </div>
        <div class="column-operation">
          <p
            v-if="item.state == 1 || item.state == 2"
            @click="delReviseOpinion(item)"
          >
            <el-popover
              placement="bottom-start"
              trigger="hover"
              width="250"
              :content="$t('profile.hoverDelete')"
            >
              <template #reference>
                <span>{{ $t('profile.deleteText') }}</span>
              </template>
            </el-popover>
          </p>
          <div>
            <div v-if="item.state == 2" class="status processing-status">
              {{ $t('profile.processing') }}
            </div>
            <div v-else-if="item.state == 1" class="status reviewing-status">
              {{ $t('profile.reviewing') }}
            </div>
            <div v-else-if="item.state == 3" class="status published-status">
              {{ $t('profile.published') }}
            </div>
            <div v-else-if="item.state == 4" class="status overuled-status">
              {{ $t('profile.overuled') }}
            </div>
          </div>
        </div>
      </div>
      <div v-show="packVisible == index" class="main">
        <div v-if="item.nonBioConcept" class="not-medical-chenck">
          <div class="title">
            {{ $t('concept.notBiomedical') }}
          </div>
          <div class="checked">
            <el-checkbox disabled v-model="item.nonBioConcept">{{
              $t('concept.notBiomedicalChecked')
            }}</el-checkbox>
          </div>
        </div>
        <div v-if="item.conceptComment" class="not-medical-content">
          <div class="wapper-title">{{ $t('concept.terminology') }}</div>
          <div class="checked">
            <el-input v-model="item.conceptComment" disabled />
          </div>
        </div>
        <div
          v-if="item.semanticType && item.semanticType.length > 0"
          class="semantic-type"
        >
          <div class="wapper-title">
            {{ $t('concept.semanticType') }}
          </div>
          <div class="wapper-context">
            <div class="wapper-box">
              <div>
                <el-tag
                  v-for="tag in item.semanticType"
                  :key="tag"
                  class="mx-1"
                >
                  {{ tag }}
                </el-tag>
              </div>
            </div>
          </div>
        </div>
        <div v-if="item.otherComment" class="wapper-semantic-other">
          <div class="wapper-title">
            {{ $t('concept.otherOpinions') }}
          </div>
          <div class="wapper-input">
            <el-input
              disabled
              v-model="item.otherComment"
              :rows="5"
              type="textarea"
            />
          </div>
        </div>
      </div>
      <div class="button">
        <img
          v-if="packVisible == index"
          src="@/common/image/profile/profile-pack-up.svg"
          alt=""
          srcset=""
          @click="packUp"
        />
        <img
          v-else
          src="@/common/image/profile/profile-pack-down.svg"
          alt=""
          srcset=""
          @click="open(index)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { delMyRevise } from '@/api/profile'
import { ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'medical-entity',
  props: {
    biosHeadCommentBoList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['requestData'],
  setup(_, { emit }) {
    const { t } = useI18n()
    const input = ref('' as string)
    const textarea = ref('' as string)
    const packVisible = ref(0)
    const open = (key: number) => {
      packVisible.value = key
    }
    const packUp = () => {
      packVisible.value = -1
    }
    const delReviseOpinion = (val) => {
      const Url = require('@/common/image/profile/profile-delete.svg')
      ElMessageBox.confirm(
        `<img class='del-logo' src="${Url}" /><p class='del-msg'>${t(
          'profile.deleteMsg'
        )}</p><p class='del-msg-one'>${t('profile.deleteMsgOne')}</p>`,
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: `${t('profile.delete')}`,
          cancelButtonText: `${t('profile.deleteCancel')}`,
          center: true,
        }
      )
        .then(async () => {
          const result = await delMyRevise(
            val.version,
            val.cid,
            1,
            val.timestamp
          )
          if (result && result.code === 0) {
            emit('requestData')
            ElMessage({
              type: 'success',
              message: result.msg,
            })
          } else {
            ElMessage({
              type: 'error',
              message: result.msg,
            })
          }
        })
        .catch(() => {})
    }
    return {
      input,
      textarea,
      packVisible,
      delReviseOpinion,
      open,
      packUp,
    }
  },
})
</script>
<style lang="less" scoped>
.medical-entity {
  position: relative;
  margin: 20px;
  border-bottom: 1px solid #dcdfe6;
  .column {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .column-time {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      color: #303133;
    }
    .column-operation {
      display: flex;
      align-items: flex-end;
      p {
        margin-right: 16px;
        span {
          font-weight: 400;
          font-size: 12px;
          line-height: 24px;
          color: #0ca1bd;
          cursor: pointer;
          border-bottom: 1px solid #0ca1bd;
        }
      }
      .status {
        padding: 2px 10px;
        border-radius: 5px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
      }
      .processing-status {
        border: 1.5px solid #2fcbb1;
        color: #2fcbb1;
      }
      .reviewing-status {
        border: 1.5px solid #fbb937;
        color: #fbb937;
      }
      .published-status {
        border: 1.5px solid #c0c4cc;
        color: #c0c4cc;
      }
      .overuled-status {
        border: 1.5px solid #ff7c7c;
        color: #ff7c7c;
      }
    }
  }
  .main {
    margin: 20px 0 20px 20px;
    .wapper-title {
      font-weight: 400;
      font-size: 12px;
      line-height: 24px;
      color: #6b727f;
    }
    .not-medical-chenck {
      .title {
        font-weight: 400;
        font-size: 12px;
        line-height: 24px;
        color: #6b727f;
      }
      .checked {
        margin-top: 14px;
      }
    }
    .not-medical-content {
      margin-top: 30px;
      .checked {
        margin-top: 14px;
      }
    }
    .semantic-type {
      margin-top: 30px;
      .wapper-context {
        margin-top: 20px;
        cursor: not-allowed;
        .wapper-box {
          padding: 2px 10px;
          width: 100%;
          min-height: 40px;
          background: #f7f8f8;
          border: 1px solid #dcdfe6;
          box-sizing: border-box;
          border-radius: 3px;
        }
      }
    }
    .wapper-semantic-other {
      margin-top: 30px;
      width: 100%;
      .wapper-input {
        margin-top: 20px;
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
      }
    }
  }
  .button {
    height: 40px;
    line-height: 40px;
    text-align: center;
    img {
      cursor: pointer;
    }
  }
}
.medical-entity:last-child {
  border-bottom: 0;
}
/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #c0c4cc;
  border-color: #e5e5e5;
}
/deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  color: #fff;
  border-color: #fff;
}
/deep/.el-input.is-disabled .el-input__inner,
/deep/.el-textarea.is-disabled .el-textarea__inner {
  background-color: #f7f8f8;
  border-color: #e5e5e5;
}
/deep/.el-tag {
  margin: 2px;
  --el-tag-background-color: #f7f8f8;
  --el-tag-border-color: #909399;
  --el-tag-font-color: #909399;
  --el-tag-hover-color: #f7f8f8;
  background-color: #f7f8f8;
  border-color: #e5e5e5;
}
</style>
<style>
@import url(./index.css);
</style>

